/* eslint-disable no-debugger */
import { useState } from 'react';
import { BASIC_INITIAL_STATE } from '../../../utils/HttpHelper';

import MeetResultsStatisticsData from './MeetResultsStatisticsData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const useMeetResultsStatisticsData = () => {
  const [meetResultsStatisticsState, setMeetResultsStatisticsState] = useState(INITIAL_STATE);

  const putMeetResultsStatistics = (meetId, numberOfSwimmers, numberOfSplashes) => {
    return MeetResultsStatisticsData.putMeetResultsStatisticsData(meetId, numberOfSwimmers, numberOfSplashes, meetResultsStatisticsState, setMeetResultsStatisticsState);  
  }

  return {
    meetResultsStatisticsState,
    putMeetResultsStatistics
  };
}
 export default useMeetResultsStatisticsData;
